import LayoutMain from "./layout/LayoutMain";
import ErrorMessage from "./ErrorMessage";
import WaterScroll from "./WaterScroll";
import XuFeiScroll from "./XuFeiScroll";
// import VueGif from './VueGif'
import VueImage from "./VueImage";
import CellInput from "./CellInput";
import Panel from "./Panel.vue";
import ScreenImg from "./ScreenImg";
import LazyDeviceScreen from "./LazyDeviceScreen";
import SafeCodeInput from "./SafeCodeInput";

const components = [
  LayoutMain,
  WaterScroll,
  XuFeiScroll,
  ErrorMessage,
  // VueGif,
  VueImage,
  CellInput,
  Panel,
  ScreenImg,
  LazyDeviceScreen,
  SafeCodeInput,
];

const install = (Vue, opts = {}) => {
  if (install.installed) return;
  for (let cop of components) {
    if (!cop.name) continue;
    Vue.component(cop.name, cop);
  }
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
export default install;
